// Must stay a NEXT_PUBLIC_ var: it is inlined into the client bundle at build time
// and used as the Datadog RUM/Logs `version` tag so errors attribute to a deploy.
export const RUM_VERSION = process.env['NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA'] || 'dev';
